/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';
require('flickity-imagesloaded');

export function moreBlogsSlider() {
  var slider = document.querySelector('.more-blogs-slider .view-content');
  var flkty = new Flickity(slider, {
    // options
    cellAlign: 'center',
    cellSelector: '.slide',
    contain: true,
    wrapAround: true,
    pageDots: true,
    prevNextButtons: false,
    watchCSS: true,
    imagesLoaded: true
  });

  var tapArea, startX ;
    tapArea = document.querySelectorAll('.more-blogs-slider .view-content');
    startX = 0;
    for (var item of tapArea) {
      item.ontouchstart = function(e) {
          startX = e.touches[0].clientX;
      };
      item.ontouchmove = function(e) {
          if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
              e.preventDefault();
          }
      };
  }
}

